import React, { useState, useEffect } from "react";
// components
import {
  Grid,
  Divider,
  Button,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Tooltip,
  TextareaAutosize,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Slider,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import L from "leaflet";
import { polylineMeasure } from "leaflet.polylinemeasure"; //do not Remove
import InputHeader from "../../components/pagesCommonComponents/InputHeader";
import InformationPopOver from "../../components/pagesCommonComponents/InformationPopOver";
import DropDown from "../../components/pagesCommonComponents/DropDown";
import "leaflet.fullscreen";
import "leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.min";
import "leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.css";
import "font-awesome/css/font-awesome.min.css";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.css";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.js";

//icons
// import { ImLocation2 } from "react-icons/im";
// import { CgErase } from "react-icons/cg";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import markerIcon from "../../images/markerIcon.png";

// style
import useStyle from "./styles";

function ValueLabelComponent(props) {
  const { children, open, value } = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

// ValueLabelComponent.propTypes = {
//   children: PropTypes.element.isRequired,
//   open: PropTypes.bool.isRequired,
//   value: PropTypes.number.isRequired,
// };

function Pollution() {
  const classes = useStyle();
  const [mapCenter, setMapCenter] = useState([24.17, 60.06]);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [typeOFOilOptions, setTypeOfOilOptions] = useState([
    { title: "Aboozar" },
    { title: "Abu al bu Khoosh" },
    { title: "Agha Jari" },
    { title: "Centa" },
    { title: "Cabinda" },
    { title: "Ceuta-Zulia" },
    { title: "Cinta" },
    { title: "Cold Lake" },
    { title: "Denver-Julesberg" },
    { title: "Djeno Bled" },
    { title: "Dorrood (Darius)" },
    { title: "Dubai (Fateh)" },
    { title: "Dukhan (Quatar Land)" },
    { title: "Dunlin" },
    { title: "Duri" },
    { title: "East Texas" },
    { title: "Centa" },
    { title: "Ekhabinskaya" },
    { title: "Ekofisk" },
    { title: "El Bunduq" },
    { title: "El Hofra" },
    { title: "Emeraude" },
    { title: "Eocene (Wafra)" },
  ]);
  const [oceanographicOptions, setOceanographicOptions] = useState([
    { title: "MFS CMEMS MED-MFC" },
    { title: "AFS" },
  ]);
  const [weatherOptions, setWeatherOptionsOptions] = useState([
    { title: "ECMWF 0.25°" },
    { title: "ECMWF 0.5°" },
    { title: "COSMO-ME" },
  ]);

  const [backdropOpen, setBackdropOpen] = useState(false);
  const backdropClose = () => {
    setBackdropOpen(false);
  };
  const polygons = [
    [
      { lat: 25.533148, lng: 57.097321 },
      { lat: 25.556695, lng: 7.085648 },
      { lat: 25.569698, lng: 57.110367 },
      { lat: 25.559787, lng: 57.129593 },
      { lat: 25.553593, lng: 57.13028 },
      { lat: 25.541202, lng: 57.11792 },
      { lat: 25.531289, lng: 57.110367 },
    ],

    [
      { lat: 25.388698, lng: 57.116547 },
      { lat: 25.398623, lng: 57.108307 },
      { lat: 25.396142, lng: 57.064362 },
      { lat: 25.371328, lng: 57.056122 },
      { lat: 25.345267, lng: 57.064362 },
      { lat: 25.315477, lng: 57.098694 },
      { lat: 25.324167, lng: 57.128906 },
      { lat: 25.347749, lng: 57.142639 },
      { lat: 25.373809, lng: 57.150879 },
    ],

    [
      { lat: 24.784241, lng: 57.623291 },
      { lat: 24.816654, lng: 57.584839 },
      { lat: 24.864011, lng: 57.609558 },
      { lat: 24.873978, lng: 57.650757 },
      { lat: 24.844073, lng: 57.669983 },
      { lat: 24.806681, lng: 57.669983 },
      { lat: 24.794215, lng: 57.667236 },
    ],

    [
      { lat: 25.334717, lng: 57.583466 },
      { lat: 25.344026, lng: 57.582436 },
      { lat: 25.345267, lng: 57.587929 },
      { lat: 25.345267, lng: 57.594109 },
      { lat: 25.340613, lng: 57.598915 },
      { lat: 25.333476, lng: 57.596512 },
      { lat: 25.332545, lng: 57.593422 },
      { lat: 25.332545, lng: 57.589645 },
      { lat: 25.332545, lng: 57.587585 },
    ],

    [
      { lat: 25.08933, lng: 57.950134 },
      { lat: 25.120419, lng: 57.944641 },
      { lat: 25.125393, lng: 57.959747 },
      { lat: 25.121663, lng: 57.983093 },
      { lat: 25.10301, lng: 57.99408 },
      { lat: 25.086843, lng: 57.98172 },
      { lat: 25.074405, lng: 57.966614 },
    ],

    [
      { lat: 25.107984, lng: 58.41156 },
      { lat: 25.160201, lng: 58.433533 },
      { lat: 25.160201, lng: 58.496704 },
      { lat: 25.140312, lng: 58.51593 },
      { lat: 25.105497, lng: 58.50769 },
      { lat: 25.073161, lng: 58.471985 },
      { lat: 25.065697, lng: 58.436279 },
    ],

    [
      { lat: 25.020907, lng: 58.859253 },
      { lat: 25.040815, lng: 58.905945 },
      { lat: 25.01344, lng: 58.919678 },
      { lat: 24.993526, lng: 58.922424 },
      { lat: 24.95618, lng: 58.922424 },
      { lat: 24.946219, lng: 58.894958 },
      { lat: 24.948709, lng: 58.842773 },
      { lat: 24.97112, lng: 58.820801 },
      { lat: 25.01344, lng: 58.829041 },
    ],

    [
      { lat: 24.542126, lng: 59.655762 },
      { lat: 24.567108, lng: 59.606323 },
      { lat: 24.61456, lng: 59.633789 },
      { lat: 24.61456, lng: 59.677734 },
      { lat: 24.607069, lng: 59.694214 },
      { lat: 24.584593, lng: 59.694214 },
      { lat: 24.569606, lng: 59.694214 },
      { lat: 24.554618, lng: 59.688721 },
    ],

    [
      { lat: 24.961783, lng: 60.170403 },
      { lat: 24.977033, lng: 60.174522 },
      { lat: 24.980768, lng: 60.192719 },
      { lat: 24.967074, lng: 60.201988 },
      { lat: 24.96116, lng: 60.200615 },
      { lat: 24.955869, lng: 60.189285 },
      { lat: 24.954312, lng: 60.179329 },
      { lat: 24.955869, lng: 60.171776 },
    ],
  ];
  useEffect(() => {
    window.sarMap = L.map("sarMap", {
      zoomControl: false,
      // fullscreenControl: true,
    }).setView(mapCenter, 7);
    L.control.zoom({ position: "bottomright" }).addTo(window.sarMap);
    L.tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
      window.sarMap,
    );

    var mbUrl =
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw";

    var dark = L.tileLayer(mbUrl, {
        id: "mapbox/dark-v10",
        tileSize: 512,
        zoomOffset: -1,
      }),
      streets = L.tileLayer(mbUrl, {
        id: "mapbox/streets-v11",
        tileSize: 512,
        zoomOffset: -1,
      }),
      satellite = L.tileLayer(mbUrl, {
        id: "mapbox/satellite-v9",
        tileSize: 512,
        zoomOffset: -1,
      }),
      light = L.tileLayer(mbUrl, {
        id: "mapbox/light-v10",
        tileSize: 512,
        zoomOffset: -1,
      });

    var baseLayers = {
      Streets: streets,
      Dark: dark,
      Light: light,
      satellite: satellite,
    };

    L.control.layers(baseLayers).addTo(window.sarMap);

    let options = {
      position: "topleft",
      clearMeasurementsOnStop: true,
      showBearings: false,
      showClearControl: true,
      showUnitControl: true,
      distanceShowSameUnit: true,
    };

    L.control.polylineMeasure(options).addTo(window.sarMap);

    L.control
      .coordinates({
        position: "bottomleft",
        decimals: 6,
        decimalSeperator: ",",
        labelTemplateLat: "Latitude: {y}",
        labelTemplateLng: "Longitude: {x}",
      })
      .addTo(window.sarMap);
    var lc = L.control
      .locate({
        position: "topright",
        strings: {
          title: "Show Your Location",
        },
      })
      .addTo(window.sarMap);

    window.sarMap.on("click", function (e) {
      setLat(e.latlng.lat);
      setLng(e.latlng.lng);
    });

    return () => {};
  }, []);

  useEffect(() => {
    if (lng && lat) {
      if (window.marker) {
        window.sarMap.removeLayer(window.marker);
        window.marker = null;
      }
      let icon = L.icon({
        iconUrl: markerIcon,
        iconSize: [38, 48],
        iconAnchor: [22, 43],
        popupAnchor: [-3, -76],
      });
      window.marker = L.marker({ lat: lat, lng: lng }, { icon: icon }).addTo(
        window.sarMap,
      );
    }
  }, [lat, lng]);

  return (
    <div className={classes.mainContainer}>
      <div className={classes.optionContainer}>
        <div className={classes.formContainer}>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.accordionHeading}>
                GENERAL PARAMETERS{" "}
                <InformationPopOver info='In "General parameters", user should enter the "Title" (any name without blank spaces and symbols) used to identify a given simulation by a unique name. "Start spill position" should be filled manually or specified by a click on the map. Three types of format are applicable: DMS Degrees/Minutes/Seconds; DMM in Degrees and Decimal Minutes; and DD in Decimal Degrees.' />
                {/* <ImLocation2 size="1.2rem" /> */}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
              <TextField
                variant="outlined"
                label="Title"
                placeholder="insert simulation name"
                // infoerText="Full width!"
                fullWidth
                margin="normal"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <div>Notes</div>
              <TextareaAutosize
                aria-label="insert your notes"
                placeholder="insert your notes"
                minRows={3}
              />
              <br />
              <div>Starting spill position</div>
              <Grid container spacing={1}>
                <Grid item>
                  <TextField
                    variant="outlined"
                    label="Latitude"
                    value={lat}
                    onChange={(e) => setLat(e.target.value)}
                    size="small"
                    style={{ width: 100 }}
                    className={classes.coordinatesInput}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    variant="outlined"
                    label="Longitude"
                    value={lng}
                    onChange={(e) => setLng(e.target.value)}
                    size="small"
                    style={{ width: 100 }}
                    className={classes.coordinatesInput}
                  />
                </Grid>
              </Grid>
              <br />
              <InputHeader
                title="TYPE OF OIL"
                info='"Type of oil" should be chosen from a given list of oil names. If an oil name is unknown, user should choose an oil API from the API-list provided.'
              />
              <br />
              <Grid container direction="row" spacing={1}>
                <Grid item xs={3}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <Select
                      labelId="type-of-oil-pollution"
                      id="type-of-oil-pollution"
                    >
                      <MenuItem value={"Name"}>Name</MenuItem>
                      <MenuItem value={"API"}>API</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={9}>
                  <DropDown options={typeOFOilOptions} />
                </Grid>
              </Grid>
              <InputHeader
                title="FORECASTING SYSTEM"
                info='In "Oceanographic forecasting system", user should choose MFS - Mediterranean Forecasting System for the whole basin or AFS - Adriatic Forecasting System for the Adriatic and Northern Ionian Seas. In "Atmospheric forecasting system", user should choose ECMWF at resolution of 12 km, 25 km or 50 km or COSMO-ME operational winds.'
              />
              <DropDown
                label="Oceanographic forecasting system "
                options={oceanographicOptions}
              />
              <br />
              <DropDown
                label=" Weather forecasting system "
                options={weatherOptions}
              />
              <br />
              <InputHeader
                title="TIME"
                info='"In "Spill date", user should specify a date when the spill starts. Dates, when the necessary oceanographic and atmospheric data are available are highlighted in a popup calendar. In "Simulation length", a number of hours from the spill date to the end of spill tracking should be entered. In "Output frequency", a time step of visualization in hours should be inserted from a drop-down menu.'
              />
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  inputVariant="outlined"
                  size="small"
                  margin="normal"
                  label="Starting spill date"
                />
              </MuiPickersUtilsProvider>
              <TextField
                variant="outlined"
                label="Simulation length [hours]"
                defaultValue={24}
                fullWidth
                margin="normal"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <FormControl
                fullWidth
                label="Output frequency [hours]"
                variant="outlined"
                size="small"
              >
                <InputLabel>Output frequency [hours]</InputLabel>

                <Select
                  labelId="Output-frequency-pollution"
                  id="Output-frequency-pollution"
                  label="Output frequency [hours]"
                  defaultValue={6}
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={6}>6</MenuItem>
                  <MenuItem value={12}>12</MenuItem>
                </Select>
              </FormControl>
              <InputHeader
                title="TYPE OF SPILL"
                info='If user needs the forecast of an "Instantaneous" spill, "Total volume" of oil in tons should be inserted. If user needs the forecast of an "Continuous" spill, "Duration" of the spill in hours and "Spill rate" in tons/hours should be inserted.'
              />
              {/* <RadioGroup
                aria-label="quiz"
                name="quiz"
                value={value}
                onChange={handleRadioChange}
              >
                <FormControlLabel
                  value="best"
                  control={<Radio />}
                  label="The best!"
                />
                <FormControlLabel
                  value="worst"
                  control={<Radio />}
                  label="The worst."
                />
              </RadioGroup> */}
              <InputHeader
                title="ADVANCED INFO"
                info='Users are recommended to follow the default values in "Advanced Info". If users have specific needs to change the parameters in this section, they can do it in the appropriate fields as follows: inactivate the "Stokes drift" by "No" button; change "Wind correction" up to 3%; insert the appropriate parameters in the fields of "Horizontal diffusivity", "Evaporation rate", "Dispersion rate", "Thick slick spreading rate", and Oil parcel number up to 30 000.'
              />
              <Grid container direction="column" spacing={2}>
                <Grid item container direction="row">
                  <Grid item xs={8}>
                    Stokes drift
                  </Grid>
                  <Grid item xs={4}>
                    <div>
                      <input
                        type="radio"
                        id="stokes-yes"
                        name="stokes"
                        value={1}
                        checked
                      />
                      Yes &nbsp;
                      <input
                        type="radio"
                        id="stokes-no"
                        name="stokes"
                        value={0}
                      />
                      No
                    </div>
                  </Grid>
                </Grid>
                <Grid item container direction="row">
                  <Grid item xs={8}>
                    Wind correction [%]
                  </Grid>
                  <Grid item xs={4}>
                    <Slider
                      ValueLabelComponent={ValueLabelComponent}
                      aria-label="custom thumb label"
                      defaultValue={0}
                      min={0}
                      max={3}
                    />
                  </Grid>
                </Grid>
                <Grid item container direction="row">
                  <Grid item xs={8}>
                    Horizontal diffusivity [m2/s]
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      defaultValue={2.0}
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                </Grid>
                <Grid item container direction="row">
                  <Grid item xs={8}>
                    Evaporation rate [m/s]
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      defaultValue={0.000033}
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                </Grid>
                <Grid item container direction="row">
                  <Grid item xs={8}>
                    Dispersion rate [l/s]
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      defaultValue={0.000008}
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                </Grid>
                <Grid item container direction="row">
                  <Grid item xs={8}>
                    Thick slick spreading rate [l/s]
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      defaultValue={150}
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                </Grid>
                <Grid item container direction="row">
                  <Grid item xs={8}>
                    Oil parcel number [#]
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      defaultValue={90000}
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.accordionHeading}>
                ADDITIONAL FEATURES{" "}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              className={classes.accordionDetails}
            ></AccordionDetails>
          </Accordion>
        </div>
        <div className={classes.submitContainer}>
          <Divider variant="middle" />
          <br />
          <Grid container justify="flex-end">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setBackdropOpen(true);
                setTimeout(() => {
                  let polygon =
                    polygons[Math.floor(Math.random() * (8 - 1 + 1)) + 1];
                  L.polygon(polygon)
                    .setStyle({ color: "gray" })
                    .addTo(window.sarMap);
                  setBackdropOpen(false);
                  window.sarMap.flyTo(polygon[0], 11, { animate: true });
                }, 2000);
              }}
            >
              Submit
            </Button>
            <Backdrop className={classes.backdrop} open={backdropOpen}>
              <CircularProgress color="inherit" />
            </Backdrop>{" "}
          </Grid>
        </div>
      </div>
      <div className={classes.mapContainer}>
        <div id="sarMap" className={classes.map}></div>
      </div>
    </div>
  );
}

export default Pollution;
